/* eslint-disable @1js/office-online-rules/no-v8-imports-for-fluentui */
import * as React from "react";

import type { ITheme } from "@fluentui/react";
import { DirectionalHint, Tooltip } from "@fluentui/react";

import { getWindowBoundsFunction } from "@1js/acui-common";
import { AppContext } from "@1js/acui-context";
import { ribbonExperiments, platformFeatures } from "@1js/acui-experiments";
import { AppThemeConsumer } from "@1js/acui-theme";
import { getBoundingWindowWithPaddingFabric } from "@1js/window-util";

import type { AppTooltipProps } from "./AppTooltip.Props";
import { getStyles } from "./AppTooltip.styles";

export class AppTooltip extends React.PureComponent<AppTooltipProps, {}> {
  declare context: React.ContextType<typeof AppContext>;

  public render() {
    const { content } = this.props;
    const resolvedContent = typeof content === "function" ? content() : content;
    const tooltipForMacIsEnabled = this.context.isPlatformFeatureEnabled?.(
      platformFeatures.tooltipForMacIsEnabled
    );
    const isBeakVisible = tooltipForMacIsEnabled
      ? { isBeakVisible: false }
      : {};
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => (
          <Tooltip
            calloutProps={{
              ...isBeakVisible,
              styles: getStyles(
                theme,
                this.props.hidden,
                this.props.delayTooltip,
                tooltipForMacIsEnabled
              ),
              beakWidth: 10,
              bounds: this.context.isExperimentalFeatureEnabled?.(
                ribbonExperiments.multiWindowSupportIsEnabled
              )
                ? getWindowBoundsFunction(this.context.appWindow)
                : getBoundingWindowWithPaddingFabric,
              gapSpace: this.props.topMargin,
              id: "Callout-" + this.props.id,
            }}
            directionalHint={
              this.props.directionalHint
                ? this.props.directionalHint
                : DirectionalHint.bottomCenter
            }
            directionalHintForRTL={this.props.directionalHintForRTL}
            content={resolvedContent}
            targetElement={this.props.targetElement}
            onMouseEnter={this.props.mouseEnterCallback}
            onMouseLeave={this.props.mouseLeaveCallback}
            id={this.props.id}
          />
        )}
      </AppThemeConsumer>
    );
  }
}

AppTooltip.contextType = AppContext;
